import { render, staticRenderFns } from "./Modulos.vue?vue&type=template&id=c6aaed80&"
import script from "./Modulos.vue?vue&type=script&lang=ts&"
export * from "./Modulos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VBtn,VContainer,VDivider,VTreeview})
